import React, { useRef, useCallback, useMemo, useEffect } from 'react';
import CheckList from 'commonComponents/CheckList/CheckList';
import Arrow from 'oldAssets/images/icons/icon-arrow-turquoise.svg';
import { InfoIcon } from 'commonComponents/icons/InfoIcon/InfoIcon';
import InfoTooltip from 'containers/Tooltips/InfoTooltip/InfoTooltip';
import classNames from 'classnames';
import styles from './Step.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const Step = ({ step, params, number, rendered, getPosition }) => {
  const { text = step, list, label, note = null, info } = step;
  const { dashed, selected } = params;
  const stepBox = useRef(null);
  const classes = useMemo(() => {
    return (
      classNames({
        [styles.Step]: true,
        [styles.selected]: selected,
        [styles.dashed]: dashed,
        [styles[`Step${number}`]]: true,
        [styles.even]: number % 2,
        [styles.rendered]: rendered,
      }));
  }, [styles, number, selected, dashed, rendered]);

  const renderItem = useCallback((item) => (
    <li className={styles.item} key={item}>
      <img src={Arrow} className={styles.marker} />
      <span className={styles.text}>{item}</span>
    </li>
  ), [styles]);

  useEffect(() => {
    getPosition(stepBox.current, number);
  }, [stepBox.current, number, getPosition]);

  return (
    <div className={classes} ref={stepBox}>
      <div className={styles.content}>
        <p>
          <span className={styles.number}>{number}.&nbsp;</span>
          <span>
            {text}
            {note && <span className={styles.note}>&nbsp;({note})</span>}
          </span>
          {info && 
          <InfoTooltip
            tip={info}
            button={<span className={styles.infoMark}>{InfoIcon}</span>}
            specialClass={styles.tooltip}
          />}
        </p>
        {list && <div className={styles.list}><CheckList list={list} render={renderItem} /></div>}
        {label && <span className={styles.optional}>{label}</span>}
      </div>
    </div>
  );
};

export default Step;
